import { useEffect } from 'react';
import { TopBar } from '../topBar/TopBar';
import './ErrorPage.css';
export const ErrorPage=()=>{
	useEffect(() => {
		document.title = `Page Not Found`;
	 },[])
return(
	<>
	<TopBar label={""}/>
    <div id="ErrorPage" className='mainContentData'>
    <div class="container w-100 h-100">
    	<h1>Not found <span>:(</span></h1>
			<p>Sorry, but the page you were trying to view does not exist.</p>
			<i>404</i>
		</div>
        </div>
	</>
)
}


export const Unauthorized=()=>{
	useEffect(() => {
		document.title = `Page Not Authorised`;
	 },[])
	return(
		<>
		<div id="ErrorPage" >
		<div class="container w-100 h-100">
			<h1>Not Authorized <span>:(</span></h1>
				<p>Sorry, but the page you were trying is Not Authorised To You.</p>
				<i>401</i>
			</div>
			</div>
		</>
	)
	}


	export const Error403 = () => {
		useEffect(() => {
			document.title = `Page Not Authorised`;
		 },[])
		return (
<>
		<div id="ErrorPage" className='ErrorPage403' >
		<div class="container w-100 h-100" >
			<h1>Access Denied <span>:(</span></h1>
				<p>Sorry, you don't have permission to access this page.</p>
				<i>403</i>
			</div>
			</div>
		</>
		);
	  };
	  